import { PromptResolve } from '@ur-solutions/react-components'
import { useForm, useTranslate } from '@ur-solutions/react-hooks'
import { RegularModal, TextArea } from 'components'

interface ApproveCommentModalProps {
  existingComment: string
  onSubmit: PromptResolve<{ comment: string } | null>
}

export const ApproveCommentModal: React.FC<ApproveCommentModalProps> = ({
  existingComment,
  onSubmit,
}) => {
  const translations = useTranslate({
    comment: 'common.comment',
  })

  const { formValues: form, formChangeHandler } = useForm<{ comment: string }>({
    values: {
      comment: existingComment,
    },
  })

  return (
    <RegularModal
      title={translations.comment}
      width="400px"
      onCancel={() => onSubmit(null)}
      onSubmit={() => onSubmit({ comment: form.comment })}
      cancelOnClickOutside
    >
      <TextArea
        width="100%"
        value={form.comment}
        onChange={formChangeHandler('comment')}
        onClick={evt => {
          evt.stopPropagation()
          evt.preventDefault()
        }}
      />
    </RegularModal>
  )
}
